/*
 * © 2025 Fannie Mae. All rights reserved.
 * This software contains confidential information and trade secrets of Fannie Mae.
 * Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.
 */

import { AccessTime } from '@material-ui/icons';
import moment from "moment";
import { isInternal } from '../../../../redux/actions/userAction';
import { REQUEST_STATUSES } from '../../../shared/constants/RequestStatuses';

// Renders the requestDate cell with a custom "clock" display according to business logic
export default (params) => {
  const requestDate = moment(params.value);
  const requestStatus = params.data?.requestStatus || params.data?.statusName || params.data?.internalStatus;
  const slaColor = params.data?.slaColor;

  const mapSlaColorToHex = (value) => {
    if (!value || typeof value !== 'string') return null;
    const normalized = value.trim().toUpperCase();
    if (normalized === 'RED') return '#dc3545';
    if (normalized === 'YELLOW' || normalized === 'AMBER') return '#ffc107';
    if (normalized === 'GREEN') return '#28a745';
    if (normalized === 'BLUE') return '#007bff';
    if (normalized === 'GREY' || normalized === 'GRAY') return '#bbbbbb';
    return null;
  };

  const calculateBusinessDaysDifference = (startDate, numberOfDays) => {
    let businessDays = 0;
    let currentDate = moment(startDate);
    while (businessDays < numberOfDays) {
      currentDate.add(1, 'day');
      if (currentDate.day() != 0 && currentDate.isoWeekday() < 6) {
        businessDays++;
      }
    }
    return currentDate;
  };

  const fallbackColor = params.data.hasDecision
    ? "#bbbbbb"
    : requestStatus === REQUEST_STATUSES.ADDITIONAL_INFORMATION_REQUIRED
    ? "#007bff"
    : moment() >= calculateBusinessDaysDifference(requestDate, 2)
    ? "#dc3545"
    : moment() >= calculateBusinessDaysDifference(requestDate, 1)
    ? "#ffc107"
    : "#28a745";

  const color = params.data.hasDecision ? '#bbbbbb' : (mapSlaColorToHex(slaColor) || fallbackColor);
  
  return (
    <>
      <span className="request-date">{requestDate.format("MM/DD/YYYY")}</span>
      {isInternal() ? (
        <span className="clock-icon">
          <AccessTime style={{
            width: 20,
            height: 18,
            marginBottom: "3px",
            color,
          }}></AccessTime>
        </span>
      ) : <></>}
    </>
  );
}